// extracted by mini-css-extract-plugin
export default {"terms":"DoG1c66bt9lkgZL1Op2c"};